import { useState } from 'react';

// Eingabe mit eigener Vorschlagsliste — HTML-datalist zeigt auf iOS nichts,
// deshalb ein eigenes Dropdown: filtert ab dem ersten Zeichen, Fokus zeigt alle.
export function AutoVervollstaendigung({ value, onChange, optionen, placeholder, onAuswahl }: {
  value: string; onChange: (v: string) => void; optionen: string[]; placeholder?: string;
  onAuswahl?: (v: string) => void;
}) {
  const [offen, setOffen] = useState(false);
  const t = value.trim().toLowerCase();
  const treffer = (t ? optionen.filter(o => o.toLowerCase().includes(t)) : optionen).slice(0, 8);
  return (
    <div className="relative">
      <input className="input w-full" value={value} placeholder={placeholder}
             onChange={e => { onChange(e.target.value); setOffen(true); }}
             onFocus={() => setOffen(true)}
             onBlur={() => setTimeout(() => setOffen(false), 150)} />
      {offen && treffer.length > 0 && (
        <div className="absolute left-0 right-0 top-full mt-1 bg-white border border-slate-200 rounded-lg shadow-lg z-20 max-h-48 overflow-y-auto">
          {treffer.map(o => (
            <button key={o} type="button"
                    className="block w-full text-left px-3 py-1.5 text-sm hover:bg-slate-100"
                    onMouseDown={e => e.preventDefault()}
                    onClick={() => { onChange(o); setOffen(false); onAuswahl?.(o); }}>
              {o}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
